<app-table
  [options]="tableOptions"
  [createDialogTmpRef]="createFormTmp"
  [editDialogTmpRef]="editFormTmp"
  (filterApply)="applyColumnFilter()"
  (filterClear)="clearAllFilter()"
  (onInitialized)="onInitTable($event)"
  (onSelectionChanged)="selectionChange($event)"
></app-table>

<ng-template #createFormTmp>
  <create-form
    [loading]="dialogLoading"
    (value)="onChangeCreateData($event)"
    (formInit)="onInitForm($event)"
  ></create-form>
</ng-template>

<ng-template #editFormTmp let-editData="data">
  <edit-form
    [data]="editData"
    [loading]="dialogLoading"
    (value)="onChangeEditData($event)"
    (formInit)="onInitForm($event)"
  ></edit-form>
</ng-template>
